export default __webpack_public_path__ + "static/media/Onboard_Hover.da1f0ead.png";